export const Title = ({ text }: { text: string }) => (
  <div className="sm:text-xl text-lg mb-5 font-bold capitalize text-[#324B4A]">{text}</div>
);
